/**
 * Одноразовая миграция: pinia-plugin-persistedstate раньше писал сторы в cookies.
 * Раздутый Cookie-header ломал /api/services/auth/user (nginx 400).
 * Persist теперь в localStorage — старые cookie сторов удаляем, auth/oauth оставляем.
 */
const LEGACY_PINIA_STORE_COOKIES = [
  'auth',
  'countriesStore',
  'organizationsStore',
] as const;

function deleteCookie(name: string) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

export default defineNuxtPlugin({
  name: 'clear-persisted-store-cookies',
  enforce: 'pre',
  setup() {
    for (const name of LEGACY_PINIA_STORE_COOKIES) {
      if (!document.cookie.split('; ').some(c => c.startsWith(`${name}=`))) {
        continue;
      }
      deleteCookie(name);
    }
  },
});
